import CodeMirror from 'codemirror';
import 'codemirror/mode/css/css';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/mode/multiplex';

// 定义 interopable-string 模式，就是那种带 花括号的字符串

CodeMirror.defineMode('interopable-string', config => CodeMirror.multiplexingMode(CodeMirror.getMode(config, 'text/plain'), {
  open: '{{',
  close: '}}',
  mode: CodeMirror.getMode(config, 'javascript'),
  delimStyle: 'interopPart',
  innerStyle: 'interopPart',
  isInsideExpr: true
}
// .. more multiplexed styles can follow here
));
CodeMirror.defineMode('interopable-css', (config, cssConfig) => CodeMirror.multiplexingMode(CodeMirror.getMode(config, {
  ...cssConfig,
  name: 'css'
}), {
  open: '{{',
  close: '}}',
  mode: CodeMirror.getMode(config, 'javascript'),
  delimStyle: 'interopPart',
  innerStyle: 'interopPart',
  isInsideExpr: true
}));
CodeMirror.defineMode('interopable-scss', (config, cssConfig) => CodeMirror.getMode(config, {
  ...cssConfig,
  name: 'text/x-scss'
}));
//# sourceMappingURL=interopable-string.js.map
